import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


import { Router } from '@angular/router';
import { ConfigSettingService } from './config-setting.service';
import { DataManipService } from './data-manip.service';
@Injectable()
export class AuthService {

  private baseURL = "";
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(private http: HttpClient,private dataManipSrvc: DataManipService, private config: ConfigSettingService, private route: Router) {
    // this.baseURL = config["EnvironmentObject"][config.Environment]["apiUrl"] + "/"
    this.baseURL = this.config.getBaseUrl();
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }



  postMethod(url, params) {
    return this.http.post<any>(url, params);
  }

  getMethod(url) {
    return this.http.get<any>(url);
  }

  getWithParams(url, params) {
    let httpparams = new HttpParams();
    httpparams = httpparams.append("criteria", JSON.stringify(params));
    return this.http.get<any>(url, { params: httpparams });
  }

  logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem('currentUser');
    this.route.navigateByUrl("/login");
    this.currentUserSubject.next(null);
    this.dataManipSrvc.apiToken = '';
    
  }

  _syncUser(data) {
    // localStorage.setItem('currentUser', JSON.stringify(data));
    this.currentUserSubject.next(data);
  }

}